import React from "react";
import "./NewElement.css";

function createDangerHTML(info) {
    return {__html : info}
}


function NewElement(props){
    console.log(props.DopInfo)
        return (

                <div className="CompanyNewsGridElement">
                    <div className={props.DopInfo ? props.DopInfo : "CompanyNewsGridElementImg03"}/>
                    <div className="CompanyNewsGridElementText">
                        <div className="CompanyNewsGridElementTextTitleDate">
                            <div className="CompanyNewsGridElementTextTitle" dangerouslySetInnerHTML= {createDangerHTML(props.NewTitle)}/>
                            <div className="CompanyNewsGridElementTextDate" dangerouslySetInnerHTML= {createDangerHTML(props.NewDate)}/>
                        </div>
                        <div className="CompanyNewsGridElementTextNews" dangerouslySetInnerHTML= {createDangerHTML(props.NewText)}/>
                    </div>
                </div>
        )}

export default NewElement









